/**
 * useSyncStatus — caller-scoped mailbox sync health.
 *
 * Calls `GET /api/me/sync-status` which returns the caller's businesses that
 * have at least one active sync issue (`reauth`, `error`, or stale). Empty
 * array = everything's green; the banner renders nothing.
 *
 * Refetched every 60s + when window focuses. Cheap enough to keep alive on
 * every inbox view since it's the primary surface for "your mailbox is dead".
 */

import { useQuery } from '@tanstack/react-query'
import { getMySyncStatus } from '@/lib/api'
import type { SyncStatusResponse } from '@/types/api'

export function useSyncStatus() {
  return useQuery<SyncStatusResponse>({
    queryKey: ['me', 'sync-status'],
    queryFn: getMySyncStatus,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  })
}
